import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from '@/shared/api/axios';
import { NAV_GROUPS } from '@/routes/paths';

/** Resolve a human section label from the current path via the nav registry. */
function sectionForPath(pathname: string): string {
  let best = '';
  let bestLen = -1;
  for (const group of NAV_GROUPS) {
    for (const item of group.items) {
      // Longest matching path prefix wins (so /accounts/sales → Accounts).
      if ((pathname === item.path || pathname.startsWith(`${item.path}/`)) && item.path.length > bestLen) {
        best = item.label;
        bestLen = item.path.length;
      }
    }
  }
  if (best) return best;
  if (pathname.startsWith('/accounts')) return 'Accounts';
  if (pathname === '/' || pathname.startsWith('/dashboard')) return 'Dashboard';
  return pathname.replace(/^\//, '') || 'Dashboard';
}

/**
 * Reports the user's current section to the server every ~20s (and immediately
 * on navigation) so the owner's Live Oversight view can show who is active and
 * where. Fire-and-forget; failures are ignored.
 */
export function usePresenceHeartbeat() {
  const location = useLocation();
  const sectionRef = useRef('');

  useEffect(() => {
    sectionRef.current = sectionForPath(location.pathname);
    const ping = () => {
      api.post('/api/presence/heartbeat', { section: sectionRef.current }).catch(() => {});
    };
    ping();
    const id = window.setInterval(ping, 20_000);
    return () => window.clearInterval(id);
  }, [location.pathname]);
}
